import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
// import auction_routes from '../views/company/auction/router.js'
import store from '../store/index'
import company_supplier_registration from "@/router/company/supplier_registration";
import company_prequal from "@/router/company/prequal";
import company_expression_of_interest from "@/router/company/expression_of_interest";
import company_assets from "@/router/company/assets";
import company_auction from "@/router/company/auction";
import company_supplier_world from "@/router/company/supplier_world";
import company_risk_management from "@/router/company/risk_management";
import company_tender from "@/router/company/tender";
import company_profile from "@/router/company/profile";
import company_landing from "@/router/company/landing";
import qed_project_management from "@/router/qed/project_management";
import company_project_management from "@/router/company/project_management";
import qed_user_management from "@/router/qed/user_management";
import qed_archive from "@/router/qed/archive";
import qed_prequal from "@/router/qed/prequal";
import qed_tender from "@/router/qed/tender";
import qed_rfq from "@/router/qed/rfq";
import qed_assets from "@/router/qed/assets";
import qed_landing from "@/router/qed/landing";
import qed_supplier_registration from "@/router/qed/supplier_registration";
import contract from "@/router/contract";
import contract_management from "@/router/contract_management";
import company_system_management from "@/router/company/system_management";
import qed_system_management from "@/router/qed/system_management";
import supplier_landing from "@/router/supplier/landing";
import qed_risk_management from "@/router/qed/risk_management";
import supplier_risk_management from "@/router/supplier/risk_management";
import archive_management from "@/router/qed/archive_management";
import qed_supplier_world from "@/router/qed/supplier_world";
import supplier_auction from "@/router/supplier/auction";
import tendersure_auction from "@/router/qed/auction";
import catalogue_management from "@/router/company/catalogue_management";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/permissions/error',
    name: 'permissions-error',
    component: () => import('../views/PermissionsError.vue')
  },
  {
    path: '/tendersure/dashboard',
    name: 'QedSourcingDashboard',
    component: () => import('../views/qed/dashboard/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      if(store.state.User.userData.user_type != 'qed') {
        next({ name: 'permissions-error' })
      }  else {
        next()
      }
    }
  },
  {
    path: '/tendersure/suppliers',
    name: 'Suppliers',
    component: () => import('../views/qed/dashboard/suppliers/Suppliers.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "page-login" */ '../views/authentication/Login.vue')
  },
  {
    path: '/sso/callback',
    name: 'SsoCallback',
    component: () => import(/* webpackChunkName: "page-sso-callback" */ '../views/authentication/SsoCallback.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "page-register" */ '../views/authentication/Register.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../views/authentication/ResetPassword.vue')
  },
  {
    path: '/activate-account',
    name: 'ActivateAccount',
    component: () => import('../views/authentication/ActivateAccount.vue')
  },
  {
    path: '/set-password/:uidb64/:token',
    name: 'SetPassword',
    component: () => import('../views/authentication/SetPassword.vue')
  },
    // Notifications urls
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('../views/notifications/Notifications.vue')
  },
  {
    path: '/company/users',
    name: 'company_users',
    component: () => import('../views/company/user_management/UserList.vue')
  },
  {
    path: '/company/roles',
    name: 'company_roles',
    component: () => import('../views/company/user_management/RoleList.vue')
  },
  {
    path: '/company/create/role',
    name: 'company_create_role',
    component: () => import('../views/company/user_management/CreateRole.vue')
  },
  {
    path: '/company/create/user',
    name: 'company_create_user',
    component: () => import('../views/company/user_management/CreateUser.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/authentication/Profile.vue')
  },
  {
    path: '/update-profile',
    name: 'UpdateProfile',
    component: () => import('../views/authentication/UpdateProfile.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'UPDATE_COMPANY_INFO')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('../views/authentication/ChangePassword.vue')
  },
  // Supplier urls
  {
    path: '/supplier/dashboard',
    name: 'SupplierSourcingDashboard',
    component: () => import('../views/supplier/dashboard/Dashboard.vue'),
    // beforeEnter: (to, from, next) => {
    //   if(store.state.User.userData.user_type != 'suppier') {
    //     next({ name: 'permissions-error' })
    //   } else {
    //     next()
    //   }
    // }
  },
  {
    path: '/supplier/dashboard/company/:id/jobs',
    name: 'SupplierCompanyJobs',
    component: () => import('../views/supplier/dashboard/CompanyJobs.vue')
  },
  {
    path: '/supplier/dashboard/company/:id/jobs/prequal/:categoryId/preview',
    name: 'PrequalQuestionPreview',
    component: () => import('../views/supplier/dashboard/preview_questions/Prequal.vue')
  },
  {
    path: '/supplier/dashboard/company/:id/jobs/supplier_registration/:categoryId/preview',
    name: 'SupplierRegistrationQuestionPreview',
    component: () => import('../views/supplier/dashboard/preview_questions/SupplierRegistration.vue')
  },
  {
    path: '/supplier/dashboard/company/:id/jobs/expression_of_interest/:categoryId/preview',
    name: 'EOIQuestionPreview',
    component: () => import('../views/supplier/dashboard/preview_questions/ExpressionofInterest.vue')
  },
  {
    path: '/supplier/dashboard/company/:id/jobs/tender/:categoryId/preview',
    name: 'TenderQuestionPreview',
    component: () => import('../views/supplier/dashboard/preview_questions/Tender.vue')
  },
  {
    path: '/supplier/dashboard/cart',
    name: 'SupplierCompanyCart',
    component: () => import('../views/supplier/dashboard/Cart.vue')
  },
  {
    path: '/supplier/payment/mpesa',
    name: 'SupplierPaymentMpesa',
    component: () => import('../views/supplier/dashboard/Mpesa.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MAKE_PAYMENTS')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/payment/cards/c',
    name: 'SupplierPaymentCellulant',
    component: () => import('../views/supplier/dashboard/Cellulant.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MAKE_PAYMENTS')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/payment/cards/pp',
    name: 'SupplierPaymentPawaPay',
    component: () => import('../views/supplier/dashboard/PawaPay.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MAKE_PAYMENTS')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/payment/cards/stp',
    name: 'SupplierPaymentSantimPay',
    component: () => import('../views/supplier/dashboard/SantimPay.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MAKE_PAYMENTS')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/payment/cards/cpp',
    name: 'SupplierPaymentChapaPayment',
    component: () => import('../views/supplier/dashboard/ChapaPayment.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MAKE_PAYMENTS')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/payment/cards/cpp/return/processing/:tx_ref/',
    name: 'ChapaPaymentProcessing',
    component: () => import('../views/supplier/payments/ChapaProcessing.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MAKE_PAYMENTS')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  // Mobile payments
  {
    path: '/supplier/payment/cards/c/:cartCode',
    name: 'MobilePaymentsCellulantInitiate',
    component: () => import('../views/supplier/mobile-payments/initiateCellulant.vue')
  },
  {
    path: '/supplier/payment/cards/re/success',
    name: 'PaymentsSuccess',
    component: () => import('../views/supplier/payments/successPayment.vue')
  },
  {
    path: '/supplier/payment/cards/re/error',
    name: 'PaymentsError',
    component: () => import('../views/supplier/payments/errorPayment.vue')
  },
  {
    path: '/supplier/payment/cards/d/return/processing',
    name: 'SupplierPaymentDPOProcessing',
    component: () => import('../views/supplier/payments/ProcessDPOPayment.vue'),
    // beforeEnter: (to, from, next) => {
    //   let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MAKE_PAYMENTS')
    //   if(obj === true) {
    //     next()
    //   } else {
    //     next({ name: 'permissions-error' })
    //   }
    // }
  },
  {
    path: '/supplier/payment/cards/pp/return/processing',
    name: 'MobilePaymentsPawaPay',
    component: () => import('../views/supplier/payments/RedirectPawaPayPayment.vue')
  },
  {
    path: '/supplier/payment/cards/d/:cartCode',
    name: 'MobilePaymentsDPOInitiate',
    component: () => import('../views/supplier/mobile-payments/initiateDPO.vue')
  },
  {
    path: '/supplier/payment/cards/d',
    name: 'SupplierPaymentDPO',
    component: () => import('../views/supplier/dashboard/DPO.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MAKE_PAYMENTS')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/payment/cards/p',
    name: 'SupplierPaymentPayfast',
    component: () => import('../views/supplier/dashboard/Payfast.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MAKE_PAYMENTS')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/ongoingbids',
    name: 'SupplierDashboardOngoingBids',
    component: () => import('../views/supplier/dashboard/OngoingBids.vue')
  },
  {
    path: '/supplier/closedbids',
    name: 'SupplierDashboardClosedBids',
    component: () => import('../views/supplier/dashboard/ClosedBids.vue')
  },
  {
    path: '/supplier/dashbard/letters',
    name: 'SupplierDashboardLetters',
    component: () => import('../views/supplier/dashboard/Letters.vue')
  },
  {
    path: '/supplier/prequal/ordered/categories',
    name: 'SupplierPrequalOrderedCategories',
    component: () => import('../views/supplier/prequal/category/OrderedCategories.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/expression_of_interest/ordered/categories',
    name: 'SupplierExpressioOfInterestOrderedCategories',
    component: () => import('../views/supplier/expression_of_interest/category/OrderedCategories.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/risk_management/jobs',
    name: 'SupplierRiskManagementOrderedCategories',
    component: () => import('../views/supplier/risk_management/List.vue'),
    // beforeEnter: (to, from, next) => {
    //   let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
    //   if(obj === true) {
    //     next()
    //   } else {
    //     next({ name: 'permissions-error' })
    //   }
    // }
  },
  {
    path: '/supplier/asset_disposal/ordered/categories',
    name: 'SupplierAssetOrderedCategories',
    component: () => import('../views/supplier/asset_disposal/OrderedCategories.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_ASSET_DISPOSAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/prequal/category/instructions/:category_id',
    name: 'SupplierPrequalCategoryInstructions',
    component: () => import('../views/supplier/prequal/category/Instructions.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/expression_of_interest/category/instructions/:category_id',
    name: 'SupplierExpressioOfInterestCategoryInstructions',
    component: () => import('../views/supplier/expression_of_interest/category/Instructions.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/prequal/preview/:category_id',
    name: 'SupplierPrequalPreview',
    component: () => import('../views/supplier/prequal/category/QuestionPreview.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/expression_of_interest/preview/:category_id',
    name: 'SupplierExpressioOfInterestPreview',
    component: () => import('../views/supplier/expression_of_interest/category/QuestionPreview.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/prequal/category/bid/:category_id',
    name: 'SupplierPrequalCategoryBid',
    component: () => import('../views/supplier/prequal/category/Bid.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/expression_of_interest/category/bid/:category_id',
    name: 'SupplierExpressioOfInterestCategoryBid',
    component: () => import('../views/supplier/expression_of_interest/category/Bid.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
    {
    path: '/supplier/tender/ordered/categories',
    name: 'SupplierTenderOrderedCategories',
    component: () => import('../views/supplier/tender/category/technical/OrderedCategories.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_TENDER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/tender/category/instructions/:category_id',
    name: 'SupplierTenderCategoryInstructions',
    component: () => import('../views/supplier/tender/category/technical/Instructions.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_TENDER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/tender/category/bid/:category_id',
    name: 'SupplierTenderCategoryBid',
    component: () => import('../views/supplier/tender/category/technical/Bid.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_TENDER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/tender/category/financial/bid/:category_id',
    name: 'SupplierTenderCategoryFinancialBid',
    component: () => import('../views/supplier/tender/category/financial/Bid.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_TENDER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/tender/category/advanced/financial/bid/:category_id',
    name: 'SupplierTenderCategoryAdvancedFinancialBid',
    component: () => import('../views/supplier/tender/category/financial/AdvancedBid.vue')
  },
  {
    path: '/supplier/tender/category/item/template/generation/progress/:category_id/:task_id',
    name: 'SupplierTenderCategoryItemGenerationProgress',
    component: () => import('../views/supplier/tender/category/financial/TemplateGenProgress.vue')
  },
    {
    path: '/supplier/tender/preview/:category_id',
    name: 'SupplierTenderPreview',
    component: () => import('../views/supplier/tender/category/technical/QuestionPreview.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_TENDER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
   // Supplier System Management urls
   {
    path: '/supplier/user/users',
    name: 'SupplierUserManagementUsers',
    component: () => import('../views/supplier/system_management/users/Users.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_USER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/user/users/create',
    name: 'SupplierUserManagementUsersCreate',
    component: () => import('../views/supplier/system_management/users/CreateUser.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_USER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/user/users/:id/update',
    name: 'SupplierUserManagementUsersUpdate',
    component: () => import('../views/supplier/system_management/users/UpdateUser.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_USER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/user/roles',
    name: 'SupplierUserManagementRoles',
    component: () => import('../views/supplier/system_management/roles/Roles.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_USER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/user/roles/create',
    name: 'SupplierUserManagementRolesCreate',
    component: () => import('../views/supplier/system_management/roles/CreateRole.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_USER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/user/roles/:id/update',
    name: 'SupplierUserManagementRolesUpdate',
    component: () => import('../views/supplier/system_management/roles/UpdateRole.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_USER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/user/roles/:id/privileges',
    name: 'SupplierUserManagementRolesPrivileges',
    component: () => import('../views/supplier/system_management/roles/Privileges.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_USER')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/user/logs',
    name: 'SupplierUserManagementLogs',
    component: () => import('../views/supplier/system_management/logs/Logs.vue')
  },
  // QED urls
  {
    path: '/tendersure/livejobs/',
    name: 'QedLiveJobs',
    component: () => import('../views/qed/dashboard/live/Jobs.vue')
  },
  {
    path: '/tendersure/livejobs/:jobId/:sourcing_activity/categories',
    name: 'QedLiveJobCategories',
    component: () => import('../views/qed/dashboard/live/Categories.vue')
  },
  {
    path: '/tendersure/livejobs/categories/:categoryId/participants',
    name: 'QedLiveJobParticipants',
    component: () => import('../views/qed/dashboard/live/Participants.vue')
  },
  {
    path: '/tendersure/jobs/buyers/',
    name: 'QedDashboardJobsBuyers',
    component: () => import('../views/qed/dashboard/jobs/Buyers.vue')
  },
  {
    path: '/tendersure/buyers/:buyerId/jobs/',
    name: 'QedDashboardJobsBuyersJobs',
    component: () => import('../views/qed/dashboard/jobs/Jobs.vue')
  },
  {
    path: '/tendersure/suppliers/',
    name: 'QedDashboardSuppliers',
    component: () => import('../views/qed/dashboard/suppliers/Suppliers.vue')
  },
  {
    path: '/tendersure/buyers/',
    name: 'BWQedBuyers',
    component: () => import('../views/qed/dashboard/buyers/Buyers.vue')
  },
  {
    path: '/tendersure/buyers/create',
    name: 'BWQedBuyersCreate',
    component: () => import('../views/qed/dashboard/buyers/CreateBuyer.vue')
  },
  {
    path: '/modules/:buyerId',
    name: 'BWQedBuyersActivate',
    component: () => import('../views/qed/dashboard/buyers/ActivateModules.vue')
  },
  {
    path: '/tendersure/buyers/:buyerId/update',
    name: 'BWQedBuyersUpdate',
    component: () => import('../views/qed/dashboard/buyers/UpdateBuyer.vue')
  },
  {
    path: '/tendersure/buyers/:buyerId/buyer',
    name: 'BWQedBuyersBuyer',
    component: () => import('../views/qed/dashboard/buyers/Buyer.vue')
  },
  {
    path: '/tendersure/buyers/:buyerId/users/create',
    name: 'BWQedBuyersUserCreate',
    component: () => import('../views/qed/dashboard/buyers/CreateBuyerUser.vue')
  },
  {
    path: '/tendersure/buyers/:buyerId/users/:id/update',
    name: 'BWQedBuyersUserUpdate',
    component: () => import('../views/qed/dashboard/buyers/UpdateBuyerUser.vue')
  },
  {
    path: '/tendersure/buyers/:buyerId/roles/create',
    name: 'BWQedBuyersRoleCreate',
    component: () => import('../views/qed/dashboard/buyers/CreateBuyerRole.vue')
  },
  {
    path: '/tendersure/buyers/:buyerId/roles/:id/update',
    name: 'BWQedBuyersRoleUpdate',
    component: () => import('../views/qed/dashboard/buyers/UpdateBuyerRole.vue')
  },
  {
    path: '/tendersure/buyers/:buyerId/roles/:id/privileges',
    name: 'BWQedBuyersRolePrivileges',
    component: () => import('../views/qed/dashboard/buyers/Privileges.vue')
  },
  {
    path: '/tendersure/savings/',
    name: 'QedSavings',
    component: () => import('../views/qed/dashboard/savings/Savings.vue')
  },
  {
    path: '/tendersure/savings/:id/buyer',
    name: 'QedBuyerSavings',
    component: () => import('../views/qed/dashboard/savings/BuyerSavings.vue')
  },
  {
    path: '/tendersure/category/types',
    name: 'QedCategoryTypes',
    component: () => import('../views/qed/system_management/category_types/List.vue')
  },
  {
    path: '/tendersure/category/type/:id',
    name: 'QedCategoryType',
    component: () => import('../views/qed/system_management/category_types/Details.vue')
  },
  {
    path: '/tendersure/category/types/create',
    name: 'QedCategoryTypeCreate',
    component: () => import('../views/qed/system_management/category_types/CreateCategoryType.vue')
  },
  {
    path: '/tendersure/category/types/edit/:category_type_id',
    name: 'QedCategoryTypeEdit',
    component: () => import('../views/qed/system_management/category_types/EditCategoryType.vue')
  },
  {
    path: '/tendersure/category/criteria/create/:category_type_id/:location_id',
    name: 'QedCategoryCriteriaCreate',
    component: () => import('../views/qed/system_management/category_types/CreateCategoryCriteria.vue')
  },
  {
    path: '/tendersure/category/criteria/edit/:category_type_id/:criteria_id',
    name: 'QedCategoryCriteriaEdit',
    component: () => import('../views/qed/system_management/category_types/EditCategoryCriteria.vue')
  },
  {
    path: '/tendersure/buyer/category/types',
    name: 'QedBuyerCategoryTypes',
    component: () => import('../views/qed/system_management/category_types/buyer_category_types/List.vue')
  },
  {
    path: '/tendersure/category/type/:id/upload-buyers',
    name: 'QedCategoryTypeBuyers',
    component: () => import('../views/qed/system_management/category_types/buyer_category_types/UploadCategoryBuyers.vue')
  },
  {
    path: '/tendersure/category/type/:id/buyer-upload-progress/:task_id',
    name: 'QedCategoryTypeBuyerUploadProgress',
    component: () => import('../views/qed/system_management/category_types/Progress.vue')
  },
  // Buyer urls
  {
    path: '/buyer/dashboard',
    name: 'BuyerSourcingDashboard',
    component: () => import('../views/company/dashboard/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      if(store.state.User.userData.user_type != 'buyer') {
        next({ name: 'permissions-error' })
      } else {
        next()
      }
    }
  },
  {
    path: '/buyer/dashboard/settings/:user_type',
    name: 'BuyerSourcingDashboardSettings',
    component: () => import('../views/company/dashboard/Settings.vue'),
    beforeEnter: (to, from, next) => {
      if(store.state.User.userData.user_type != 'buyer') {
        next({ name: 'permissions-error' })
      } else {
        next()
      }
    }
  },
  {
    path: '/buyer/livejobs/',
    name: 'BuyerLiveJobs',
    component: () => import('../views/company/dashboard/live/Jobs.vue')
  },
  {
    path: '/buyer/bidders/',
    name: 'BuyerLiveJobBidders',
    component: () => import('../views/company/dashboard/bidders/Bidders.vue')
  },
  {
    path: '/buyer/livejobs/:jobId/:sourcing_activity/categories',
    name: 'BuyerLiveJobCategories',
    component: () => import('../views/company/dashboard/live/Categories.vue')
  },
  {
    path: '/buyer/livejobs/categories/:categoryId/participants',
    name: 'BuyerLiveJobParticipants',
    component: () => import('../views/company/dashboard/live/Participants.vue')
  },
  {
    path: '/buyer/ourjobs/',
    name: 'BuyerOurJobs',
    component: () => import('../views/company/dashboard/OurJobs.vue')
  },
  {
    path: '/buyer/savings/',
    name: 'BuyerSavings',
    component: () => import('../views/company/dashboard/Savings.vue')
  },
  // Risk Management urls

    // Auctions urls
    //  Document Templates
  {
    path: '/company/document-templates',
    name: 'BuyerDocumentTemplates',
    component: () => import('../views/company/document_templates/DocumentTemplates.vue')
  },
    //  Document Templates
    // Buyer

  // System Management urls
  {
    path: '/buyer/user/users',
    name: 'CompanySystemUserManagementUsers',
    component: () => import('../views/company/system_management/users/Users.vue')
  },
  {
    path: '/buyer/user/users/create',
    name: 'CompanySystemUserManagementUsersCreate',
    component: () => import('../views/company/system_management/users/CreateUser.vue')
  },
  {
    path: '/buyer/user/users/:id/update',
    name: 'CompanySystemUserManagementUsersUpdate',
    component: () => import('../views/company/system_management/users/UpdateUser.vue')
  },
  {
    path: '/buyer/user/roles',
    name: 'CompanySystemUserManagementRoles',
    component: () => import('../views/company/system_management/roles/Roles.vue')
  },
  {
    path: '/buyer/user/roles/create',
    name: 'CompanySystemUserManagementRolesCreate',
    component: () => import('../views/company/system_management/roles/CreateRole.vue')
  },
  {
    path: '/buyer/user/roles/:id/update',
    name: 'CompanySystemUserManagementRolesUpdate',
    component: () => import('../views/company/system_management/roles/UpdateRole.vue')
  },
  {
    path: '/buyer/user/roles/:id/privileges',
    name: 'CompanySystemUserManagementRolesPrivileges',
    component: () => import('../views/company/system_management/roles/Privileges.vue')
  },
  {
    path: '/buyer/user/logs',
    name: 'CompanySystemUserManagementLogs',
    component: () => import('../views/company/system_management/logs/Logs.vue')
  },
  //RFQ Urls
  {
    path: '/company/rfqs',
    name: 'company_rfqs',
    component: () => import('../views/company/rfq/List.vue')
  },
  //for cic
  {
    path: '/company/list-rfqs',
    name: 'companyRFQJobs',
    component: () => import('../views/company/rfq/cic/RFQJobs.vue')
  },
  {
    path: '/company/awarded-rfqs',
    name: 'companyRFQAwardedJobs',
    component: () => import('../views/company/rfq/cic/AwardedRFQs.vue')
  },
  {
    path: '/company/create-rfqs',
    name: 'companyCreateJobCategory',
    component: () => import('../views/company/rfq/cic/CreateJobCategory.vue')
  },
  {
    path: '/company/edit-rfq/:rfq_id/:category_id',
    name: 'companyEditJobCategory',
    component: () => import('../views/company/rfq/cic/EditJobCategory.vue')
  },
  // end cic
  // create RFQ
  {
    path: '/company/create/rfq',
    name: 'CompanyRfqCreate',
    component: () => import('../views/company/rfq/Create.vue')
  },

  // RFQ Details
  {
    path: '/company/rfq/details/:id',
    name: 'CompanyRfqDetails',
    component: () => import('../views/company/rfq/Details.vue')
  },
  // create RFQ category
  {
    path: '/company/rfq/create/category/:id',
    name: 'CompanyRfqCategoryCreate',
    component: () => import('../views/company/rfq/category/Create.vue')
  },
    {
    path: '/company/rfq/category/duplicate/:id/:category_id',
    name: 'CompanyRfqCategoryDuplicate',
    component: () => import('../views/company/rfq/category/DuplicateCategory.vue')
  },
  {
    path: '/company/create/rfq-negotiation/:job_id/:parent_id',
    name: 'CompanyRfqCreateNegotiation',
    component: () => import('../views/company/rfq/category/CreateNegotiation.vue')
  },
  // RFQ category details
  {
    path: '/company/rfq/category/details/:rfq_id/:category_id',
    name: 'CompanyRfqCategoryDetails',
    component: () => import('../views/company/rfq/category/Details.vue')
  },
  // RFQ edit category
  {
    path: '/company/rfq/edit/category/:rfq_id/:category_id',
    name: 'CompanyRfqCategoryEdit',
    component: () => import('../views/company/rfq/category/Edit.vue')
  },
  //RFQ Invited suppliers
  {
    path: '/company/rfq/invited/suppliers/:rfq_id/:category_id',
    name: 'CompanyRfqInvitedSupplier',
    component: () => import('../views/company/rfq/category/invitees/Invitees.vue')
  },
  //RFQ Invite bidders from prequal
  {
    path: '/company/rfq/invite/from/prequal/list/:rfq_id/:category_id',
    name: 'CompanyRfqInviteFromPrequalification',
    component: () => import('../views/company/rfq/category/invitees/Prequalifications.vue')
  },
  {
    path: '/company/rfq/invite/from/prequal/category/list/:rfq_id/:category_id/:prequal_id',
    name: 'CompanyRfqInviteFromPrequalCategories',
    component: () => import('../views/company/rfq/category/invitees/PrequalCategories.vue')
  },
  {
    path: '/company/rfq/invite/from/prequal/category/suppliers/:rfq_id/:category_id/:prequal_id/:p_cat_id',
    name: 'CompanyRfqInviteFromPrequalCategorySuppliers',
    component: () => import('../views/company/rfq/category/invitees/PrequalCategorySuppliers.vue')
  },

  //RFQ Supplier List
  {
    path: '/supplier/list/rfqs',
    name: 'SupplierRFQList',
    component: () => import('../views/supplier/rfq/List.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_RFQ')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/apply/rfq/:category_id',
    name: 'SupplierRfqApply',
    component: () => import('../views/supplier/rfq/Apply.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_RFQ')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/apply/rfq/advanced/:category_id',
    name: 'supplierApplyAdvancedRFQ',
    component: () => import('../views/supplier/rfq/advanced_rfq/Apply.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_RFQ')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/rfq/category/item/template/generation/progress/:category_id/:task_id',
    name: 'SupplierRFQCategoryItemGenerationProgress',
    component: () => import('../views/supplier/rfq/advanced_rfq/TemplateGenProgress.vue')
  },
  //RFQ Job Reports
  {
    path: '/company/rfq/job/reports/:rfq_id',
    name: 'CompanyRfqJobReports',
    component: () => import('../views/company/rfq/reports/List.vue')
  },
  {
    path: '/company/rfq/report/progress/:prequal_id/:task_id',
    name: 'companyRFQProgress',
    component: () => import('../views/company/rfq/reports/Progress.vue')
  },
  {
    path: '/company/rfq/category/upload/progress/:category_id/:task_id',
    name: 'companyRFQCategoryUploadProgress',
    component: () => import('../views/company/rfq/category/UploadProgress.vue')
  },
  {
    path: '/company/rfq/category/download/progress/:category_id/:task_id',
    name: 'companyRFQCategoryDownloadProgress',
    component: () => import('../views/company/rfq/category/DownloadProgress.vue')
  },
  {
    path: '/company/rfq/cat/suppliers/progress/:tender_id/:task_id/',
    name: 'CompanyRFQCatSuppliers',
    component: () => import('../views/company/rfq/RFQCatSupplierProgress.vue')
  },
  {
    path: '/company/rfq/category/refresh/scores/:prequal_id/:category_id/:task_id',
    name: 'CompanyRFQCategoryRefreshProgress',
    component: () => import('../views/company/rfq/category/RefreshScoresProgress.vue')
  },
  // Archive
  // Buyer
  {
    path: '/company/archive/jobs',
    name: 'SWCompanyArchiveJobs',
    component: () => import('../views/company/archive/Jobs.vue')
  },
  {
    path: '/company/archive/jobs/:jobId/:sourcing_activity/categories',
    name: 'SWCompanyArchiveJobsCategories',
    component: () => import('../views/company/archive/Categories.vue')
  },
  {
    path: '/company/archive/jobs/:jobId/:sourcing_activity/categories/:categoryId/suppliers',
    name: 'SWCompanyArchiveJobsCategorySuppliers',
    component: () => import('../views/company/archive/Suppliers.vue')
  },
  {
    path: '/company/archive/:sourcing_activity/categories/:categoryId/suppliers/:supplierId',
    name: 'SWCompanyArchiveSupplierDocuments',
    component: () => import('../views/company/archive/SupplierDocuments.vue')
  },
  // Supplier
  {
    path: '/supplier/archive/companies',
    name: 'SWCompanyArchiveCompanies',
    component: () => import('../views/supplier/archive/Companies.vue')
  },
  {
    path: '/supplier/archive/companies/:companyId/categories',
    name: 'SWCompanyArchiveCompanyCategories',
    component: () => import('../views/supplier/archive/Categories.vue')
  },
  {
    path: '/supplier/archive/:jobType/categories/:categoryId/documents',
    name: 'SWCompanyArchiveCompanyCategoriesDocuments',
    component: () => import('../views/supplier/archive/SupplierDocuments.vue')
  },

  // Supplier Assets
  {
    path: '/supplier/asset/job/:category_id',
    name: 'SupplierAssetApply',
    component: () => import('../views/supplier/asset_disposal/bid.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier'
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/asset/job/basic/:category_id',
    name: 'SupplierAssetBasicApply',
    component: () => import('../views/supplier/asset_disposal/Basic.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier'
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/asset_disposal/category/item/template/generation/progress/:category_id/:task_id',
    name: 'SupplierAssetTemplateGenerationProgress',
    component: () => import('../views/supplier/asset_disposal/TemplateGenProgress.vue')
  },

  {
    path: '/supplier/asset/category/bid/:category_id',
    name: 'SupplierAssetCategoryBidTechnical',
    component: () => import('../views/supplier/asset_disposal/technical.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_ASSET_DISPOSAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },

  {
    path: '/supplier/asset/category/instructions/:category_id',
    name: 'SupplierAssetCategoryInstructions',
    component: () => import('../views/supplier/asset_disposal/Instructions.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_ASSET_DISPOSAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },

  // Supplier Registration
  {
    path: '/supplier/supplier-registration/ordered/categories',
    name: 'SupplierRegistrationOrderedCategories',
    component: () => import('../views/supplier/supplier_registration/OrderedCategories.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/supplier-registration/category/instructions/:category_id',
    name: 'SupplierRegistrationCategoryInstructions',
    component: () => import('../views/supplier/supplier_registration/Instructions.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/supplier-registration/preview/:category_id',
    name: 'SupplierRegistrationPreview',
    component: () => import('../views/supplier/supplier_registration/QuestionPreview.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/supplier/supplier-registration/category/bid/:category_id',
    name: 'SupplierRegistrationCategoryBid',
    component: () => import('../views/supplier/supplier_registration/Bid.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },

  // risk management
  {
    path: '/supplier/risk_management/category/instructions/:category_id',
    name: 'SupplierRiskManagementCategoryInstructions',
    component: () => import('../views/supplier/risk_management/Instructions.vue'),
    // beforeEnter: (to, from, next) => {
    //   let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
    //   if(obj === true) {
    //     next()
    //   } else {
    //     next({ name: 'permissions-error' })
    //   }
    // }
  },
  {
    path: '/supplier/risk_management/category/bid/:category_id',
    name: 'SupplierRiskManagementCategoryBid',
    component: () => import('../views/supplier/risk_management/Bid.vue'),
    // beforeEnter: (to, from, next) => {
    //   let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
    //   if(obj === true) {
    //     next()
    //   } else {
    //     next({ name: 'permissions-error' })
    //   }
    // }
  },
  {
    path: '/supplier/risk_management/preview/:category_id',
    name: 'SupplierRiskManagementPreview',
    component: () => import('../views/supplier/risk_management/QuestionPreview.vue'),
    // beforeEnter: (to, from, next) => {
    //   let obj = store.state.User.userData.user_type === 'supplier' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_PREQUAL')
    //   if(obj === true) {
    //     next()
    //   } else {
    //     next({ name: 'permissions-error' })
    //   }
    // }
  },
  {
      path: '/tendersure/supplier/update/:id',
      name: 'SwQedSupplierUpdate',
      component: () => import('../views/qed/dashboard/suppliers/UpdateSupplier.vue')
  },
  {
      path: '/tendersure/supplier/categories/:id',
      name: 'SwQedSuppliersCategoriesList',
      component: () => import('../views/qed/dashboard/suppliers/CategorySuppliers.vue')
  },
  {
    path: '/tendersure/category/types/progress/:task_id',
    name: 'reports_progress',
    component: () => import('../views/qed/system_management/category_types/Progress.vue'),
  },


    // asset disposal urls
    ...company_assets,
    // end of asset disposal urls

     // auction urls
     ...company_auction,
     // end of auction urls

    // supplier auction
      ...supplier_auction,
    // end of supplier auction

    // tendersure auction
      ...tendersure_auction,
    // end of tendersure auction

    // risk management urls
    ...company_risk_management,
    // end of risk management urls

    // company supplier registration urls
    ...company_supplier_registration,
    // end of company supplier registration urls

    // company prequal urls
    ...company_prequal,
    // end of company prequal urls

    // company expression of interest urls
    ...company_expression_of_interest,
    // end of company expression of interest urls

     // company tender urls
    ...company_tender,
    // end of company tender urls

     // company profile urls
    ...company_profile,
    // end of company profile urls

    // company supplier world urls
    ...company_supplier_world,
    // end of company supplier world urls

    // company landing urls
    ...company_landing,
    // end of company landing urls

    // qed project management urls
    ...qed_project_management,
    // end of qed project management urls

    // company project management urls
    ...company_project_management,
    // end of company project management urls

    // qed user management urls
    ...qed_user_management,
    // end of qed user management urls

    // qed archive urls
    ...qed_archive,
    // end of qed archive urls

    // qed prequal urls
    ...qed_prequal,
    // end of qed prequal urls

    // qed tender urls
    ...qed_tender,
    // end of qed tender urls

    // qed rfq urls
    ...qed_rfq,
    // end of qed rfq urls

    // qed assets urls
    ...qed_assets,
    // end of qed assets urls

    // qed landing urls
    ...qed_landing,
    // end of qed landing urls

    // qed supplier registration urls
    ...qed_supplier_registration,
    // end of qed supplier registration urls

    // qed supplier world urls
    ...qed_supplier_world,
    // end of qed supplier world urls

    // qed supplier registration urls
    ...qed_risk_management,
    // end of qed supplier registration urls

    // contract urls
    ...contract,
    ...contract_management,
    // end of contract urls

    // supplier landing urls
    ...supplier_landing,
    // end of supplier landing urls

    // supplier risk management urls
    ...supplier_risk_management,
    // end of supplier risk management urls

    // supplier risk management urls
    ...archive_management,
    // end of supplier risk management urls

    //
    ...company_system_management,
    //

    //
    ...qed_system_management,
    //

    // company catalogue management
    ...catalogue_management
    // end of company catalogue management

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  store.dispatch('Loading/clearLoadingTasks')
  const authExceptions = [
    'Login', 'SsoCallback', 'Register', 'ResetPassword', 'SetPassword', 'ActivateAccount', 
    'MobilePaymentsCellulantInitiate', 'MobilePaymentsCellulantSuccess', 'MobilePaymentsCellulantError', 
    'MobilePaymentsDPOInitiate', 'SupplierPaymentDPOProcessing'
  ]
  if (!authExceptions.includes(to.name) && store.state.Auth.authUser === null) {
    return next({ name: 'Login', query: {
      returnUrl: to.fullPath,
    }})
  } else {
    if(to.name == 'Home'){
      if(store.state.User.userData?.user_type === 'supplier') {
        return next({ name: 'SupplierSourcingDashboard' })
      } else if(store.state.User.userData?.user_type === 'buyer') {
        return next({ name: 'CompanyLanding' })
      } else if(store.state.User.userData?.user_type === 'temp') {
        return next({ name: 'ContractManagementDashboard' })
      }else if(store.state.User.userData?.user_type === 'qed') {
        return next({ name: 'QedLanding' })
      }
    }else{
      return next()
    }
  }
});

export default router
